import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../lib/queryKeys";
import { getEncounterDrg } from "../../services";

export const useEncounterDrg = (
  params: Record<string, string>,
  enabled = true
) =>
  useQuery({
    queryKey: queryKeys.encounterDrg(params),
    queryFn: () => getEncounterDrg(params),
    enabled: enabled && Boolean(params.mrn_no),
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 404) return false;
      return failureCount < 1;
    },
  });
